import api from "./api";

const cityCatalogRequests = new Map();

export function normalizeCityName(value) {
  return (value || "")
    .normalize("NFKD")
    .replace(/\p{Diacritic}/gu, "")
    .trim()
    .toLocaleLowerCase()
    .replace(/\s+/g, " ");
}

export function loadIndianCityCatalog(context = "event") {
  if (!cityCatalogRequests.has(context)) {
    const request = api.get("/catalog/cities/options", { params: { context } })
      .then(({ data }) => {
        if (!data || !Array.isArray(data.popular) || !Array.isArray(data.cities)) {
          throw new Error("Indian city catalog returned an invalid response");
        }
        return {
          popular: data.popular.filter((city) => typeof city?.name === "string"),
          cities: data.cities.filter((city) => typeof city?.name === "string"),
          aliases: [...data.popular, ...data.cities].reduce((map, city) => {
            if (typeof city?.name !== "string") return map;
            for (const alias of [city.name, ...(Array.isArray(city.aliases) ? city.aliases : [])]) {
              map[normalizeCityName(alias)] = city.name;
            }
            return map;
          }, {}),
        };
      })
      .catch((error) => {
        cityCatalogRequests.delete(context);
        throw error;
      });
    cityCatalogRequests.set(context, request);
  }
  return cityCatalogRequests.get(context);
}

export function loadIndianCities(context = "event") {
  return loadIndianCityCatalog(context).then(({ popular, cities }) => (
    [...popular, ...cities].map((city) => city.name)
  ));
}
